<template lang="pug">
.wrap
  nav#navbar.navbar.navbar-collapse.navbar-default.navbar-fixed-top
    .nav.navbar-header
      a.navbar-brand(v-link="{ path: '/' }")
        img(:class="{'hidden-xs': mobileCurrent}" src="./logo.png" height="50")
        div.visible-xs.current-page(v-show='mobileCurrent') {{mobileCurrent | wordDict}}
      //- .navbar-right.show-menu
      //-   button.navbar-toggle(
      //-     type="button"
      //-     data-toggle="collapse"
      //-     data-target="#menu"
      //-     aria-expanded="false"
      //-     aria-controls='nav'
      //-   )
      //-     span.sr-only Toggle navigation
      //-     span.icon-bar
      //-     span.icon-bar
      //-     span.icon-bar
    .navbar-right
      ul.nav.navbar-nav.hidden-xs
        li
          a(v-link="{ path: '/about/profile'}" v-bind:class="{ 'active': hasRoute('/about') }") {{'MENU_ABOUT' | wordDict}}
        li
          a(v-link="{ path: '/portfolio', activeClass: 'active'}") {{'MENU_PORTFO' | wordDict}}
        li
          a(v-link="{ path: '/news/media' , activeClass: 'active' }") {{'MENU_NEWS' | wordDict}}
        li
          a(v-link="{ path: '/downloads' , activeClass: 'active' }", v-if="isLoggedin") {{'MENU_DOWNLOAD' | wordDict}}

      .side(@mouseleave='mouseLeftHamburger()')
        button.navbar-toggle(@mouseenter='showMenu()')
          span.close-menu(:class="{'enabled': displayMenu}", @click='hideMenu()')
            i.fa.fa-times
          span.show-menu(:class="{'disabled': displayMenu}", @click='showMenu()')
            span.sr-only Toggle navigation
            span.icon-bar
            span.icon-bar
            span.icon-bar

        ul#menu.nav.navbar-nav(:class='{"show-menu": displayMenu}', flex="column justify-center align-center")
          li.item.visible-xs#menu-home(@click='hideMenu()')
            a(v-link="{ path: '/', activeClass: 'active'}") {{'MENU_HOME' | wordDict}}
          li.item.visible-xs(@click='hideMenu()')
            a(v-link="{ path: '/about/profile'}" v-bind:class="{ 'active': hasRoute('/about') }") {{'MENU_ABOUT' | wordDict}}
          li.item.visible-xs(@click='hideMenu()')
            a(v-link="{ path: '/portfolio', activeClass: 'active'}") {{'MENU_PORTFO' | wordDict}}
          li.item.visible-xs(@click='hideMenu()')
            a(v-link="{ path: '/news/media' , activeClass: 'active' }") {{'MENU_NEWS' | wordDict}}
          li.item.visible-xs(@click='hideMenu()')
            a(v-link="{ path: '/downloads' , activeClass: 'active' }", v-if="isLoggedin") {{'MENU_DOWNLOAD' | wordDict}}
          li.item(@click='hideMenu()')
            a(v-link="{ path: '/job', activeClass: 'active' }") {{'MENU_JOB' | wordDict}}
          li.item(@click='hideMenu()')
            a(v-link="{ path: '/contact', activeClass: 'active' }") {{'MENU_CONTACT' | wordDict}}
          li.item(@click='hideMenu()')
            a(href='?lang={{toLang}}') {{langOption}}
          li.item(@click='hideMenu()')
            a(href="https://www.aidjapan.co.jp/", target="_blank") {{'MENU_JP' | wordDict}}
          li.item(@click='hideMenu()', v-if="!isLoggedin")
            a(v-link="{ path: '/login', activeClass: 'active' }") {{'MENU_LOGIN' | wordDict}}
          li.item(@click='hideMenu()', v-if="isLoggedin")
            a(@click="logout()") {{'MENU_LOGOUT' | wordDict}}
</template>

<script>
import axios from 'axios'
import router from './../../router'

export default {
  data () {
    return {
      langOption: window.lang == 'en'? '繁體': 'English',
      toLang: window.lang == 'en'? 'zh-Hant': 'en',
      displayMenu: false,
    }
  },
  computed: {
    mobileCurrent() {
      const wordDictKey = {
        'about': 'MENU_ABOUT_US',
        'portfolio': 'MENU_PORTFO',
        'contact': 'MENU_CONTACT',
        'news': 'MENU_NEWS',
        'job': 'MENU_JOB',
        'downloads': 'MENU_DOWNLOAD',
        'login': 'MENU_LOGIN',
      }
      return wordDictKey[this.$route.path.split('/')[1]]
    },
    isLoggedin() {
      return this.$root.user != null
    }
  },
  ready () {},
  attached () {},
  methods: {
    hasRoute: function (partial) {
      // use v-bind:class with have route to active hight with all subroutes
      return (this.$route.path.indexOf(partial) > -1)
    },
    showMenu() {
      this.displayMenu = true;
    },
    hideMenu() {
      this.displayMenu = false;
    },
    mouseLeftHamburger() {
      if (!$('#menu-home').is(':visible')) {
        this.displayMenu = false;
      }
    },
    logout() {
      axios.post('/api/logout')
      .then((response) => {
        this.$root.user = null
        router.go('/')
      })
      .catch(function (error) {
        console.log(error);
      });
    },
  },
  components: {}
}
</script>

<style lang="scss">
@import "global";
$sideber-height: 56px;
$side-menu: #003471;
#navbar {
  padding-left: 115px;
  padding-right: 115px;
  @media(max-width: $grid-float-breakpoint-max) {
    min-height: $sideber-height;
    height: $sideber-height;
    .nav.navbar-header {
      display: inline-block;
      float: left
    }
  }
  @media (max-width:$grid-float-breakpoint-max) {
    padding-left: 0;
    padding-right: 0;
  }
  .navbar-brand {
    padding-top: 15px;
    img {
      background-color: transparent;
    }
    .current-page {
      display: none;
    }
    @media(max-width: $grid-float-breakpoint-max) {
      height: $sideber-height;
      padding: 9px 12px;
      img {
        height: 38px;
      }
      .current-page {
        height: 38px;
        font-size: 18px;
        font-weight: 900;
        text-transform: uppercase;
        color: #000;
        padding: 9px 5px; //actually 9.5 is better?
      }
    }
  }
  li > a {
    text-transform: uppercase;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    cursor: pointer;
    &.hover {
      color:#333;
    }
    &.active {
      color: $color-tab;
    }
  }

  .side {
    float: right;
    @media (max-width: $grid-float-breakpoint-max) {
      height: $sideber-height;
      width: $sideber-height;
      display: flex;
      flex-direction: row;
      justify-content: center;
      background: $color-tab;

    }
    .navbar-toggle {
      background-color: #FFF;
      border-color: #FFF;
      display: block;
      .show-menu {
        display:block;
        .icon-bar {
          background-color: #000;
        }
      }
      .close-menu{
        display: none;
        .fa {
          font-size: 22px;
          color: #fff;
          width: 22px;
        }
      }
      @media (max-width: $grid-float-breakpoint-max) {
        z-index: 2;
        width: 56px;
        height: 56px;
        border-radius: 0;
        border: 0;
        padding: 9px 16px;
        margin: 0;
        background-color: $side-menu;
        border-color: $side-menu;
        .show-menu {
          .icon-bar {
            background-color: #FFF;
          }
          &.disabled {
            display:none;
          }
        }
        .close-menu.enabled {
          display:block;
        }
      }
    }
    #menu {

      background-color: $side-menu;
      right: 0;
      top:80px;
      height: 100%;
      position: fixed;
      z-index: 1;
      @media (max-width:$grid-float-breakpoint-max) {
        top: 0;
        width: 100%;
        margin: 0;
      }
      li.item {
        float: none;
        width: 100%;
        a {
          font-size: 20px;
          font-weight: bold;
          letter-spacing: 5px;
          color: #FFF;
          padding: 25px 100px;
        }
        &:hover {
          background: #FFF;
          a {
            color: $side-menu;
          }
        }
        &:active {
          background: #FFF;
        }
        @media (max-width:$grid-float-breakpoint-max) {
          &:hover {
            background-color: #387ec0;
            > a {
              color: #fff;
            }
          }
          a {
            letter-spacing: 0;
            font-size: 14px;
            padding: 16px;
          }
        }
      }
    }
  }
}



#menu {
  transform: translateX(100%) !important;
  transition: transform .5s ease-in;
  &.show-menu {
    transform: translateX(0) !important;
  }
}

.item {
  display: block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// navigation.vue?27df2eae